import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex align-items-center p-1 justify-content-between w-full",
  style: {"height":"28px"}
}

import { StudentAttendanceInterface } from '@/types';
import { toRefs } from 'vue';

interface StudentsPropsInterface {
  lowAttendance: boolean;
  student: StudentAttendanceInterface;
  skey: string;
  selected: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentPercentage',
  props: {
    lowAttendance: { type: Boolean },
    student: {},
    skey: {},
    selected: { type: Boolean }
  },
  emits: ['studentSelected'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { student, selected, skey } = toRefs(props);
const emit = __emit;

const onSelectStudent = (student: StudentAttendanceInterface, key: string) => {
  emit('studentSelected', student, key);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    key: _unref(student).id,
    class: _normalizeClass(["mb-2 font-bold border-round-lg cursor-pointer", { 'selected bg-primary-lighter': _unref(selected), ' p-1 surface-100 raised': !_unref(selected) }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onSelectStudent(_unref(student), _unref(skey))))
  }, [
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_unref(student).full_name), 1),
      _createElementVNode("span", {
        class: _normalizeClass({ 'text-alert-red': __props.lowAttendance })
      }, _toDisplayString(_unref(student).percentage) + "%", 3)
    ])
  ], 2))
}
}

})